import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Instagram, Mail, Send } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Create mailto link with form data
    const subject = encodeURIComponent(`New inquiry from ${formData.name}`);
    const body = encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`);
    // Open email client
    window.location.href = `mailto:underlinedbydania@gmail.com?subject=${subject}&body=${body}`;
    // Reset form
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <section id="contact" className="px-6 py-24 md:py-32 max-w-7xl mx-auto" data-id="element-30">
      <div className="max-w-4xl mx-auto" data-id="element-31">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-32">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-serif mb-8 text-[#4A3B47]" data-id="element-33">
            Ready to make your brand feel like{' '}
            <span className="italic text-[#A88B9D]" data-id="element-34">home</span>?
          </h2>

          <p className="text-xl text-[#4A3B47]/70 max-w-2xl mx-auto" data-id="element-35">
            Let's create a space where your customers want to stay. Reach out
            and let's start a conversation about your vision.
          </p>
        </motion.div>

        <motion.div className="max-w-xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-36">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-37">
            <div data-id="element-38">
              <label htmlFor="name" className="block text-sm font-medium text-[#4A3B47] mb-2" data-id="element-39">
                Your Name
              </label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 bg-[#F5F0F3] border border-transparent rounded-xl text-[#4A3B47] placeholder-[#4A3B47]/40 focus:outline-none focus:border-[#A88B9D] focus:ring-1 focus:ring-[#A88B9D] transition-colors" placeholder="Jane Smith" data-id="element-40" />
            </div>

            <div data-id="element-41">
              <label htmlFor="email" className="block text-sm font-medium text-[#4A3B47] mb-2" data-id="element-42">
                Email Address
              </label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 bg-[#F5F0F3] border border-transparent rounded-xl text-[#4A3B47] placeholder-[#4A3B47]/40 focus:outline-none focus:border-[#A88B9D] focus:ring-1 focus:ring-[#A88B9D] transition-colors" placeholder="jane@company.com" data-id="element-43" />
            </div>

            <div data-id="element-44">
              <label htmlFor="message" className="block text-sm font-medium text-[#4A3B47] mb-2" data-id="element-45">
                Tell me about your project
              </label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-4 py-3 bg-[#F5F0F3] border border-transparent rounded-xl text-[#4A3B47] placeholder-[#4A3B47]/40 focus:outline-none focus:border-[#A88B9D] focus:ring-1 focus:ring-[#A88B9D] transition-colors resize-none" placeholder="I'm looking to build a community around my startup..." data-id="element-46" />
            </div>

            <motion.button type="submit" className="w-full py-4 px-8 bg-[#4A3B47] text-white rounded-xl font-medium hover:bg-[#5a4b57] focus:outline-none focus:ring-2 focus:ring-[#A88B9D] focus:ring-offset-2 transition-colors" whileHover={{
            scale: 1.01
          }} whileTap={{
            scale: 0.99
          }} data-id="element-47">
              Send Message
            </motion.button>
          </form>

          <div className="mt-12 pt-8 border-t border-[#4A3B47]/10 text-center" data-id="element-48">
            <p className="text-[#4A3B47]/60 mb-4" data-id="element-49">Or reach out directly</p>
            <a href="mailto:underlinedbydania@gmail.com" className="text-[#4A3B47] hover:text-[#A88B9D] transition-colors font-medium" data-id="element-50">
              underlinedbydania@gmail.com
            </a>

            <div className="flex items-center justify-center gap-8 mt-8" data-id="element-51">
              <a href="https://www.linkedin.com/in/underlinedbydania/" target="_blank" rel="noopener noreferrer" className="text-[#4A3B47]/60 hover:text-[#A88B9D] transition-colors" aria-label="LinkedIn" data-id="element-52">
                <Linkedin className="w-6 h-6" data-id="element-53" />
              </a>
              <a href="https://www.instagram.com/underlinedbydania/" target="_blank" rel="noopener noreferrer" className="text-[#4A3B47]/60 hover:text-[#A88B9D] transition-colors" aria-label="Instagram" data-id="element-54">
                <Instagram className="w-6 h-6" data-id="element-55" />
              </a>
              <a href="mailto:underlinedbydania@gmail.com" className="text-[#4A3B47]/60 hover:text-[#A88B9D] transition-colors" aria-label="Email" data-id="element-56">
                <Mail className="w-6 h-6" data-id="element-57" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}